import React from 'react';
import LoginQuery from "./LoginQuery";

function ProgressBar(props) {

    const {width, attachLoginQuery} = props;

    return (
        <>
            <div className=" flex flex-row progressBar h-1 rounded-lg mt-2 w-full justify-center">
                <div className="flex flex-row  h1 bg-dark-pink rounded-lg w-20">
                    <div className={`h1 bg-light-pink rounded-lg ${width}`}></div>
                </div>
            </div>

            { attachLoginQuery && <LoginQuery /> }

        </>
    );
}

export default ProgressBar;